/* --------------------------------------------------------------------------
   useForecastViewState.js – share UI state (mode & horizon) between the
   TankForecastChart component and sibling widgets such as MetricsCards.  

   Having a single source of truth ensures the chart and the summary cards
   stay in sync when the user switches between Level / Usage mode or chooses
   a different forecast horizon (30, 60, 90 days, …).
--------------------------------------------------------------------------- */

import { ref } from 'vue';

// Selected forecast horizon (days to show)
export const selectedRange = ref(30);   // 30 | 60 | 90 | 183 | 365

// Display mode – matches the buttons in TankForecastChart.vue
// • 'level'   – tank level forecast
// • 'usage'   – tank usage / consumption forecast
export const selectedMode  = ref('level');

// Convenience default export so consumers can use either syntax:
//   import { selectedRange, selectedMode } from '…'
//   import viewState from '…';  viewState.selectedRange.value = …
export default {
  selectedRange,
  selectedMode,
};
